import { setToken, removeToken, getToken } from "@/api/token";
import type { AgentSeller } from "@/types/auth";
import { create } from "zustand";
import { persist } from "zustand/middleware";
import { useContactStore } from "./contact.store";
import { useTdaStore } from "./tda.store";

interface AuthUser {
  agentCompanySellerId: string;
  name: string;
  tokenExpiredDate: string;
  agentCompanyId: string;
  isAllowBoardingPass: boolean;
}

interface AuthState {
  user: AuthUser | null;
  login: (data: AgentSeller) => void;
  updateUserName: (name: string) => void;
  logout: () => void;
  isTokenExpired: () => boolean;
  isAuthenticated: () => boolean;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      user: null,
      login: (data) => {
        setToken(data.token);
        set({
          user: {
            agentCompanySellerId: data.agentCompanySellerId,
            name: data.name,
            tokenExpiredDate: data.tokenExpiredDate,
            agentCompanyId: data.agentCompanyId,
            isAllowBoardingPass: data.isAllowBoardingPass,
          },
        });
      },
      updateUserName: (name) => {
        set((state) =>
          state.user ? { user: { ...state.user, name } } : state,
        );
      },
      logout: () => {
        removeToken();
        useContactStore.getState().clearContact();
        useTdaStore.getState().clearVerifiedTdaPassengers();
        set({ user: null });
      },
      isTokenExpired: () => {
        const user = get().user;
        if (!user) return true;
        return new Date(user.tokenExpiredDate).getTime() < Date.now();
      },
      isAuthenticated: () => {
        return !!getToken() && !get().isTokenExpired();
      },
    }),
    { name: "auth-user" },
  ),
);
